import React from 'react'
import cn from 'classnames'
import SatsIcon from 'components/shared/SatsIcon'
import type { DailyMoney } from './dailyMoney'
import styles from './daily-money-value.module.scss'

// A daily-rule money value: the bolt glyph leading sats, the bare dollar
// string otherwise. Sized by the surrounding font (the bolt is em-scaled).
export default function DailyMoneyValue({
    className,
    iconClassName,
    money,
}: {
    className?: string
    iconClassName?: string
    money: DailyMoney
}) {
    return (
        <span className={cn(styles.value, className)} data-money-unit={money.unit}>
            {money.unit === 'sats' && (
                <SatsIcon inline contextStyles={cn(styles.bolt, iconClassName)} />
            )}
            <span className={styles.text}>{money.text}</span>
        </span>
    )
}
